var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { FaTrash, FaUndo, FaLink } from 'react-icons/fa';
import { assetUrl } from '../../utils/img';
function EntityArtManager({ levelId, refreshTrigger, title, containerClassName, listImages, listArchivedImages, archiveImage, restoreImage, linkage, }) {
    const [images, updateImages] = useImmer([]);
    const [archivedImages, updateArchivedImages] = useImmer([]);
    const [linkedEntities, updateLinkedEntities] = useImmer([]);
    const load = () => __awaiter(this, void 0, void 0, function* () {
        if ((linkage === null || linkage === void 0 ? void 0 : linkage.strategy) === 'parallel') {
            const [active, archived, linked] = yield Promise.all([
                listImages(levelId),
                listArchivedImages(levelId),
                linkage.load(levelId),
            ]);
            updateImages(() => active);
            updateArchivedImages(() => archived);
            updateLinkedEntities(() => linked);
            return;
        }
        const [active, archived] = yield Promise.all([
            listImages(levelId),
            listArchivedImages(levelId),
        ]);
        updateImages(() => active);
        updateArchivedImages(() => archived);
        if (linkage) {
            // Load the linked entities to compute the badges
            try {
                const linked = yield linkage.load(levelId);
                updateLinkedEntities(() => linked);
            }
            catch (err) {
                console.error(linkage.loadErrorMessage, err);
            }
        }
    });
    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [levelId, refreshTrigger]);
    const handleArchive = (id) => __awaiter(this, void 0, void 0, function* () {
        yield archiveImage(id);
        load();
    });
    const handleRestore = (id) => __awaiter(this, void 0, void 0, function* () {
        yield restoreImage(id);
        load();
    });
    return (_jsxs("div", { className: containerClassName, children: [_jsx("div", { className: "dialogues-art-header", children: _jsx("h3", { children: title }) }), _jsxs("div", { className: "dialogues-art-grid", children: [images.map(img => {
                        const badge = linkage ? linkage.describeLinks(img, linkedEntities) : null;
                        return (_jsxs("div", { className: "image-tile", children: [_jsx("img", { src: assetUrl(img.imageUrl), alt: img.filename }), badge && badge.count > 0 && (_jsx("div", { className: "link-badge-container", children: _jsxs("div", { className: "link-badge", title: badge.badgeTitle, children: [_jsx(FaLink, { className: "link-icon" }), _jsx("span", { className: "link-text", children: badge.badgeText })] }) })), _jsx("button", { className: "delete-btn", onClick: () => handleArchive(img.id), title: "Archive", children: _jsx(FaTrash, {}) })] }, img.id));
                    }), images.length === 0 && (_jsx("div", { className: "empty-state", children: "No images uploaded yet." }))] }), archivedImages.length > 0 && (_jsxs(_Fragment, { children: [_jsx("h4", { className: "archived-title", children: "Archived" }), _jsx("div", { className: "dialogues-art-grid archived-grid", children: archivedImages.map(img => (_jsxs("div", { className: "image-tile archived", children: [_jsx("img", { src: assetUrl(img.imageUrl), alt: img.filename }), _jsx("div", { className: "archived-actions", children: _jsx("button", { className: "restore-btn", onClick: () => handleRestore(img.id), title: "Restore", children: _jsx(FaUndo, {}) }) })] }, img.id))) })] }))] }));
}
export default EntityArtManager;
